export default "__VITE_ASSET__CRyI3StG__"